/**
 * Phaser Game Configuration
 * Mobile-optimized settings following mobile-dev skill
 */

import Phaser from 'phaser';
import { GAME_CONFIG, PERFORMANCE } from '../constants/GameConstants';
import { BootScene } from '../scenes/BootScene';
import { PreloadScene } from '../scenes/PreloadScene';
import { MenuScene } from '../scenes/MenuScene';
import { MapScene } from '../scenes/MapScene';
import { BattleScene } from '../scenes/BattleScene';
import { PuzzleScene } from '../scenes/PuzzleScene';
import { ShopScene } from '../scenes/ShopScene';
import { HealScene } from '../scenes/HealScene';
import { TreasureScene } from '../scenes/TreasureScene';
import { FloorTransitionScene } from '../scenes/FloorTransitionScene';
import { RewardScene } from '../scenes/RewardScene';
import { BossIntroScene } from '../scenes/BossIntroScene';
import { RunSummaryScene } from '../scenes/RunSummaryScene';
import { SettingsScene } from '../scenes/SettingsScene';
import { DebugScene } from '../scenes/DebugScene';

const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_CONFIG.WIDTH,
  height: GAME_CONFIG.HEIGHT,
  parent: 'game',
  backgroundColor: '#2c3e50',

  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_CONFIG.WIDTH,
    height: GAME_CONFIG.HEIGHT,
    min: {
      width: 360,
      height: 640,
    },
    max: {
      width: 1440,
      height: 2560,
    },
  },

  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 }, // Top-down game, no gravity
      debug: false,
    },
  },

  fps: {
    target: PERFORMANCE.TARGET_FPS,
    min: PERFORMANCE.MIN_FPS,
    forceSetTimeOut: false,
  },

  render: {
    pixelArt: false,
    antialias: true,
    antialiasGL: true,
    roundPixels: true,
  },

  scene: [BootScene, PreloadScene, MenuScene, MapScene, BattleScene, PuzzleScene, ShopScene, HealScene, TreasureScene, RewardScene, FloorTransitionScene, BossIntroScene, RunSummaryScene, SettingsScene, DebugScene],
};

export default gameConfig;
